import { app } from 'app/app';
import React, { useContext, useEffect } from 'react';
import {Header} from 'components/dashboard/layout/Header.js';
import SecureSiteWarning from 'components/dashboard/layout/SecureSiteWarning.js';
import {Sidebar} from 'components/dashboard/layout/Sidebar.js';
import {Footer} from 'components/dashboard/layout/Footer.js';
import {Alerts} from "components/common/Alerts";
import 'assets/sass/dashboard/layout/Layout.scss';
import { AppContext } from 'app/state/AppContext';
import PendingDocuments from './PendingDocuments';


export const DashboardLayout = ({alerts, children}) => {
    const { marketIdentifiers, marketTickers } = useContext(AppContext);

    useEffect(
        () => {
            if (marketIdentifiers.length) {
                app.updateMarketTickers(marketIdentifiers, marketTickers);
            }
        },
        [marketIdentifiers]
    );

    return (
        <main className="dashboard">
            <SecureSiteWarning />
            <Header />
            <Alerts alerts={alerts}/>
            <div className="dashboard-main">
                <Sidebar/>
                <div className="dashboard-content">
                    {children}
                </div>
            </div>
            <Footer/>
            <PendingDocuments />
        </main>
    );
}
